
import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";


export const loadPermissions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/permissions', state.permissions)
            .then((response) => {
                if(!response.fromState) commit(types.ADD_PERMISSIONS, response.data.permissions)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadAllPermissions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/sub/module/permission', state.all)
            .then((response) => {
                if(!response.fromState) commit(types.LOAD_PERMISSIONS, response.data)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })

}


